import { Encrypt } from './base.models';
/**
 * This is auto-generated code. DO NOT EDIT IT!!
 * Any manual change on this file will disappear on
 * next code generation
 */
import { PlayersAmount } from './enums';
import { MoneyPot } from './money-pot.entity';

export class CreateGameRequest {
	public playersAmount: PlayersAmount;
	@Encrypt()
	public password?: string;
	public name: string;
	public owner: string;
	public moneyPot?: MoneyPot;

	constructor(values: CreateGameRequest) {
		for (const [key, value] of Object.entries(values)) this[key] = value;
	}
}
